import type { ReactElement } from "react"
import type { TableMolProps } from "@onestore/hel/dist/components/molecules/TableMol"
import TableMol from "@onestore/hel/dist/components/molecules/TableMol"
import _t from "@core/i18n"
import { getTableAriaLabels } from "~/helpers/getTableAriaLabels"
import useHeaderHeightSpace from "~/hooks/useHeaderHeightSpace"
import { sendContentShowEvent } from "~/lib/analytics"

type TableMolWrapperProps = Omit<TableMolProps, "ariaLabels">

export default function TableMolWrapper({
  showMoreDetails,
  ...tableProps
}: TableMolWrapperProps): ReactElement<TableMolProps> {
  const headerHeightSpace = useHeaderHeightSpace()

  const showMoreDetailsWithOnClick = {
    ...showMoreDetails,
    onClick: sendContentShowEvent,
  }

  return (
    <TableMol
      showMoreDetails={showMoreDetailsWithOnClick}
      pushTopSpace={headerHeightSpace}
      ariaLabels={{
        ...getTableAriaLabels(),
        iconTrueAriaLabel: _t("tableAriaLabels.iconTrue"),
        iconFalseAriaLabel: _t("tableAriaLabels.iconFalse"),
      }}
      {...tableProps}
    />
  )
}
